import { globals } from '../utils';
import { DEVICE_TYPES_ENUM } from '../utils/deviceTypes';
let instance;
let semaphore = false;
export async function getInstance() {
    if (!instance && !semaphore) {
        const Orchestra = await import(
        /* webpackChunkName: "orchestra" */
        '@amzn/Orchestrajs');
        instance =
            instance ||
                new Orchestra.Player({
                    version: 1,
                    appVersion: globals.amznMusic.appConfig.version,
                    appName: 'WebCP',
                    hostname: globals.location.hostname +
                        (globals.location.port ? `:${globals.location.port}` : ''),
                    musicTerritory: globals.amznMusic.appConfig.musicTerritory,
                    clientId: 'WebCP',
                    streamingQuality: 'STANDARD',
                    deviceTypeId: globals.amznMusic.appConfig.deviceType || DEVICE_TYPES_ENUM.AWW0SCLEVHN20,
                    customerId: Date.now(),
                    deviceId: Date.now(),
                    flags: {
                        metrics: false,
                        broadcast: false,
                    },
                    crossDomain: true,
                    csrf: globals.amznMusic.appConfig.csrf,
                    tier: globals.amznMusic.appConfig.tier || process.env.tier,
                    marketplaceId: globals.amznMusic.appConfig.marketplaceId || process.env.marketplaceId,
                });
    }
    semaphore = true;
    return instance;
}
export function getInstanceSync() {
    return instance;
}
